$(function () {
    $(document).on('click', '[js-booking-service]', function () {
        var $this = $(this),
            $modal = $($this.data('modal'));
        // $modal.find('[name=_target]').val($this.data('target'));
        // $modal.find('#card-name').html($this.data('title'));
        $$.openModal($modal);
    });
});